import {createAction} from '@reduxjs/toolkit';

export const clearError = createAction('CLEAR_ALERTS_ERROR');

